<template>
  <footer>
    <div class="container-fluid wrap">
      <div class="row center-xs">
        <div class="col-xs">
          <span>Copyright © </span>
          <SfLink target="_blank" :link="link">FrogzeeCommerce</SfLink> {{ version }}-{{ stage }}.
          <span>{{ $t('All rights reserved') }}.</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { SfLink } from '@storefront-ui/vue';

export default {
  name: 'Footer',
  components: {
    SfLink,
  },
  data() {
    return {
      link: 'https://www.frogzee.com/',
      version: process?.env?.VUE_APP_VERSION,
      stage: process?.env?.VUE_APP_STAGE || 'default',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/helpers';
@import 'src/scss/_breakpoint';
footer {
  --link-font-size: var(--font-xs);
  background-color: var(--_c-light-primary);
  padding: var(--spacer-sm) 0;
}
span {
  font: var(
    --link-font,
    var(--link-font-weight, var(--font-normal)) var(--link-font-size, var(--font-xs)) /
      var(--link-font-line-height, 1.4) var(--link-font-family, var(--font-family-secondary))
  );
}
</style>
